module.exports = __webpack_public_path__ + "img/567144989.0f0ffa77.jpg";